import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import CustomSelect from '../../../ui/CustomSelect';

const jobFamilyOptions = [
  { value: 'Staff', label: 'Staff' },
  { value: 'Supervisor', label: 'Supervisor' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Director', label: 'Director' },
];

export default function JobGradeModal({ open, data, saving, onClose, onSave }) {
  const [form, setForm] = useState(data || {});

  useEffect(() => {
    setForm(data || {});
  }, [data]);

  if (!open) return null;

  const handleSubmit = e => {
    e.preventDefault();
    onSave({
      ...form,
      grade_level: parseInt(form.grade_level),
      min_salary: parseFloat(form.min_salary),
      mid_salary: parseFloat(form.mid_salary),
      max_salary: parseFloat(form.max_salary),
    });
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] overflow-hidden animate-modal">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">{form?.id ? 'Edit' : 'Tambah'} Golongan Jabatan</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 space-y-4 max-h-[60vh] overflow-y-auto">
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Kode Golongan <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={form?.grade_code || ''}
                onChange={e => setForm({ ...form, grade_code: e.target.value })}
                placeholder="I, II, III"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Nama Golongan <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={form?.grade_name || ''}
                onChange={e => setForm({ ...form, grade_name: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Level (1-10) <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                value={form?.grade_level || 1}
                onChange={e => setForm({ ...form, grade_level: e.target.value })}
                min="1"
                max="10"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Job Family <span className="text-red-500">*</span>
              </label>
              <CustomSelect
                value={form?.job_family || 'Staff'}
                onChange={val => setForm({ ...form, job_family: val })}
                options={jobFamilyOptions}
                placeholder="Pilih job family"
                width="w-full"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Gaji Minimum (Rp) <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                value={form?.min_salary || 0}
                onChange={e => setForm({ ...form, min_salary: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Gaji Mid-Point (Rp) <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                value={form?.mid_salary || 0}
                onChange={e => setForm({ ...form, mid_salary: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
            <div className="space-y-1 md:col-span-2">
              <label className="text-sm font-medium text-gray-700">
                Gaji Maximum (Rp) <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                value={form?.max_salary || 0}
                onChange={e => setForm({ ...form, max_salary: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">Deskripsi</label>
            <textarea
              value={form?.description || ''}
              onChange={e => setForm({ ...form, description: e.target.value })}
              rows={2}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 font-medium"
          >
            Batal
          </button>
          <button
            onClick={handleSubmit}
            disabled={saving}
            className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 disabled:opacity-50 font-medium"
          >
            {saving ? 'Menyimpan...' : 'Simpan'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
